import canvasManager from "slotworks/graphics/canvas/canvas-manager";
import GraphicsManager from "slotworks/graphics/graphics-manager";
import Layers from "slotworks/graphics/layers/layers";
import particleManager from "slotworks/graphics/particles/particle-manager";
import Point from "slotworks/utils/geom/point";
import { AngleBetween } from "slotworks/utils/math/angle";
import Timer from "slotworks/utils/timer";
import * as TweenJS from "slotworks/utils/tween";

export class BigWinFirework {

    private burst: number;
    private spark: number;

    private target: Point;
    private layer: PIXI.Container;

    constructor() {
        this.launchFirework();
    }

    private launchFirework() {

        this.layer = new PIXI.Container();
        Layers.CelebrationForeground.add(this.layer);
        this.target = new Point(Math.random() * canvasManager.stageWidth, Math.random() * canvasManager.stageHeight);

        const firework = GraphicsManager.createSprite("HardRain");
        firework.y = canvasManager.stageHeight;
        firework.x = this.target.x - 400 + Math.random() * 800;
        firework.rotation = AngleBetween(firework, this.target);

        this.layer.addChild(firework);

        new TweenJS.Tween(firework)
            .to(this.target, 200)
            .onComplete(() => {
                this.layer.removeChild(firework);
                firework.destroy();
                this.explodeFirework();
            })
            .start();
    }

    private explodeFirework() {

        this.burst = particleManager.add("bigWinFireworkBurst", new Point(0, 0), this.layer);
        this.spark = particleManager.add("bigWinFireworkSpark", new Point(0, 0), this.layer);

        particleManager.get(this.burst).spawnPos.x = particleManager.get(this.spark).spawnPos.x = this.target.x;
        particleManager.get(this.burst).spawnPos.y = particleManager.get(this.spark).spawnPos.y = this.target.y;

        Timer.setTimeout(() => this.destroy(), 3000);
    }

    private destroy() {
        particleManager.remove(this.burst);
        particleManager.remove(this.spark);
    }
}
